import React from "react";
import { Box, Typography, Step, StepLabel, Stepper } from "@mui/material";
import { usePayment, useTheme } from "../hooks";
import { useTranslation } from "react-i18next";

const PaymentHeader = ({
  isCustomerSearchEnabled = false,
}: {
  isCustomerSearchEnabled: boolean;
}) => {
  const { currentStep } = usePayment();
  const { theme } = useTheme();
  const { t } = useTranslation();

  const steps = [
    ...(isCustomerSearchEnabled ? [t("payment.steps.customer_search")] : []),
    t("payment.steps.choose_method"),
    t("payment.steps.review_confirm"),
  ];

  return (
    <Box sx={{ py: 1, mb: 2 }}>
      {/* 55% suits desktop; on a phone it pushed the third step off-screen. */}
      <Box sx={{ maxWidth: { xs: "100%", md: "55%" }, mx: "auto", px: 1 }}>
        <Stepper activeStep={currentStep - 1}>
          {steps.map((label, index) => (
            <Step key={label} completed={currentStep > index + 1}>
              <StepLabel
                sx={{
                  "& .MuiStepLabel-label": {
                    color:
                      currentStep === index + 1
                        ? theme?.color_primary
                        : "inherit",
                  },
                  "& .MuiStepIcon-root.Mui-active": {
                    color: theme?.color_primary,
                  },
                  "& .MuiStepIcon-root.Mui-completed": {
                    color: theme.color_primary,
                  },
                }}
              >
                <Typography variant="body2" fontWeight="medium">
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default PaymentHeader;
